import React from "react";
import star from "../../../Assets/Homeimgs/star.svg";
import { FaStar } from "react-icons/fa";

const CourseCard = ({ course, navigate }) => {
  return (
    <div
      className="group relative rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md p-4 sm:p-5 shadow-xl shadow-slate-950/40 hover:-translate-y-1 hover:border-[#5989C8]/70 transition-all duration-200"
      data-aos="fade-up"
    >
      <div className="relative overflow-hidden rounded-2xl mb-4">
        <img
          src={course.image}
          alt={course.title}
          className="w-full h-44 sm:h-52 lg:h-60 object-cover rounded-2xl transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-transparent to-transparent opacity-70" />
        <span className="absolute left-3 top-3 rounded-full bg-slate-900/80 border border-white/10 px-3 py-1 text-[11px] text-slate-100">
          Top Course
        </span>
      </div>

      <div className="space-y-3">
        <h2 className="text-base sm:text-lg font-semibold text-white">
          {course.title}
        </h2>

        <div className="flex items-center justify-between text-xs sm:text-sm text-slate-300/90">
          <p>{course.lessons} Lessons</p>
          <p>{course.assignments} Assignments</p>
          <p>{course.duration}</p>
        </div>

        <div className="flex items-center justify-between mt-1">
          <div className="flex items-center gap-2">
            <div className="flex items-center">
              {[...Array(Math.floor(course.rating))].map((_, i) => (
                <FaStar key={i} className="h-4 w-4 text-yellow-400" />
                // <img key={i} src={star} alt="star" className="h-4 w-4" />
              ))}
            </div>
            <span className="text-xs sm:text-sm text-slate-300">
              {course.rating} ({course.reviews})
            </span>
          </div>

          <button
            className="inline-flex items-center justify-center rounded-full bg-[#064585] px-3 sm:px-4 py-2 text-xs sm:text-sm font-semibold text-white shadow-lg shadow-[#064585]/40 hover:bg-[#033465] hover:-translate-y-0.5 transition-all duration-200"
            onClick={() => {
              navigate(`/courses/${course.id}`);
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
